import { z } from 'zod';

export const ReviewDTO = z.object({
    id: z.string(), // FIXME: should be optional/nullable according to the API documentation
    title: z.string().nullish(),
    body: z.string().nullish(),
    userName: z.string().nullish(),
    rating: z.number(), // FIXME: should be optional/nullable according to the API documentation
    createdAt: z.string(), // FIXME: should be optional/nullable according to the API documentation
    contextualData: z
        .array(
            z.object({
                id: z.enum(['Gender', 'Age', 'ExperienceDachat']),
                value: z.string(),
                label: z.string(),
            }),
        )
        .optional(),
    isRecommended: z.boolean(),
    locale: z.string().nullish(),
    loyaltyStatus: z.string().optional(), // FIXME: in the API documentation, this field is required
    badge: z.string(),
    // FIXME: should be optional/nullable according to the API documentation
    helpfulness: z.object({
        positiveCount: z.number(),
        negativeCount: z.number(),
    }),
    syndication: z
        .object({
            name: z.string().nullish(),
            imageUrl: z.string().nullish(),
            url: z.string().nullish(),
        })
        .nullish(),
});
export type ReviewDTO = z.infer<typeof ReviewDTO>;
